<template>
  <div class="base-bg" v-if="visible">
    <TopBar
      :title="$t('edit.editActionTitles.adsSets')"
      @onClickClose="close"
      @onClickSave="handleSubmit"
    ></TopBar>
    <div class="set-content">
      <MediaSelect
        :url="form.cover.pc"
        :title="$t('enum.covers.2')"
        :btnTitle="$t('actionTitles.changeCover')"
        @changeMedia="updatePCCover"
        @deleteMedia="deletePCCover"
        :isEdit="(!userConfig || +userConfig.edit_cover === 1) && (userInfo.level > 0 || userInfo.team_id > 0)"
        size="1920 x 1080"
      ></MediaSelect>
      <MediaSelect
        :url="form.cover.mob"
        :title="$t('enum.covers.3')"
        :btnTitle="$t('actionTitles.changeCover')"
        @changeMedia="updateMbCover"
        @deleteMedia="deleteMbCover"
        :isEdit="(!userConfig || +userConfig.edit_cover === 1) && (userInfo.level > 0 || userInfo.team_id > 0)"
        size="480 x 800"
      ></MediaSelect>
      <MediaSelect
        :url="form.logo"
        :title="$t('edit.settings.companyLogo')"
        :btnTitle="$t('actionTitles.changeCover')"
        @changeMedia="updateLogo"
        @deleteMedia="deleteLogo"
        :isEdit="(!userConfig || +userConfig.edit_logo_fix === 1) && (userInfo.level > 0 || userInfo.team_id > 0)"
        size="200 x 200"
      ></MediaSelect>
      <MediaSelect
              :inputValue="form.author"
              :mediaType="-2"
              :isEdit="!userConfig || +userConfig.edit_logo_fix === 1"
              :title="$t('edit.settings.authName')"
              @changeMedia="updateAuthName"
      ></MediaSelect>
      <MediaSelect
        :inputValue="form.top_ad"
        :mediaType="-1"
        :isEdit="!userConfig || +userConfig.edit_top_ad === 1"
        :title="$t('edit.settings.scrollTxt')"
        @changeMedia="updateTopAd"
      ></MediaSelect>
    </div>
  </div>
</template>

<script>
import TopBar from "./TopBar.vue";
import MediaSelect from "./MediaSelect.vue";
import { mapGetters } from "vuex";

import { getTree as getCateTree } from "@/api/cate";

export default {
  components: {
    TopBar,
    MediaSelect,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        author: '',
        cover: {
          pc: "",
          mob: "",
        },
        logo: "http://qiniu.vipyun.vip/1812/works/7510212bb95f1259/thumb.jpg",
        fix_logo: {
          land: "",
          sky: "",
        },
        bgm: "http://oss.wa720.com/1/media/msc/b62bce80247fe9b6.mp3",
        bgv: "",
        top_ad: "",
      },
    };
  },
  computed: { ...mapGetters(["vrbase", "userConfig",'userInfo']) },
  created() {
    this.form = this.$deepClone(this.vrbase.ads);
    if(!this.form.author){
      this.form.author = this.userInfo.name;
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    updatePCCover(data) {
      this.form.cover.pc = data.url;
    },
    updateMbCover(data) {
      this.form.cover.mob = data.url;
    },
    updateLogo(data) {
      this.form.logo = data.url;
    },
    deletePCCover() {
      this.form.cover.pc = "";
    },
    deleteMbCover() {
      this.form.cover.mob = "";
    },
    deleteLogo() {
      this.form.logo = "";
    },
    updateAuthName(data){
      this.form.author = data
    },
    updateTopAd(data) {
      this.form.top_ad = data;
    },
    handleSubmit() {
      const vrbase = { ...this.vrbase, ads: this.form };
      this.$store
        .dispatch(
          "saveVRBase",
          {
            vrbase,
            showLoading: true,
          },
          true
        )
        .then(() => {
          this.$emit("close");
          // this.$message.success(this.$t("message.saveSuccess"));
        });
    },
  },
};
</script>

<style lang="less" scoped>
.base-bg {
  // /deep/ .ant-input,
  // /deep/ .ant-select-selection,
  // /deep/ .ant-input-number-input {
  //   background-color: #333 !important;
  //   border: 1px solid #555;
  //   color: #fff;
  // }

  // /deep/ .ant-form-item-label > label {
  //   color: #fff !important;
  // }

  // /deep/ span + * {
  //   color: #fff;
  // }
}
</style>
